import { render } from "./LayerOne.vue?vue&type=template&id=3b8aece9&scoped=true&ts=true"
import script from "./LayerOne.vue?vue&type=script&lang=ts"
export * from "./LayerOne.vue?vue&type=script&lang=ts"

import "./LayerOne.vue?vue&type=style&index=0&id=3b8aece9&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8aece9"]])

export default __exports__